module.exports = __webpack_public_path__ + "static/media/et_1.9ecc3d18.png";